export default __webpack_public_path__ + "static/footer-logo-3c2ff33db74280bb7d418ed565288ed7.png";